module.exports = __webpack_public_path__ + "static/media/5J1A6677_Small.99155061.jpg";